// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__xORFe","error":"TextArea_error__Q5oDD"};